import styled from 'styled-components';
import { clsPrefix } from '../../action-card.styled';

export const ActionCardTitleDescSC = styled.div`
  .${clsPrefix}-title {
    color: ${({ theme }) => theme.color.tint.action};
    ${({ theme }) => theme.mappedTypography.h6.default};
  }

  .${clsPrefix}-description {
    margin-top: 4px;
    color: ${({ theme }) => theme.color.tint.secondary};
    ${({ theme }) => theme.mappedTypography.captionLarge.default};

    .${clsPrefix}-done & {
      color: ${({ theme }) => theme.color.tint.success};
    }

    .${clsPrefix}-onHold & {
      background-color: ${({ theme }) => theme.color.surface.info};
    }

    .${clsPrefix}-error & {
      color: ${({ theme }) => theme.color.tint.error};
    }
  }
`;
